import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const projectImages = [
  "https://defra.co.id/images/project/p1.jpg",
  "https://defra.co.id/images/project/p2.jpg",
  "https://defra.co.id/images/project/p26.jpg",
  "https://defra.co.id/images/project/p23.jpg",
  "https://defra.co.id/images/project/p4.jpg",
  "https://defra.co.id/images/project/p27.jpg",
  "https://defra.co.id/images/project/p8.jpg",
  "https://defra.co.id/images/project/pxn.jpeg",
  "https://defra.co.id/images/project/p22.jpg",
  "https://defra.co.id/images/project/p10n.jpeg",
  "https://defra.co.id/images/project/p31.jpg",
  "https://defra.co.id/images/project/p13.jpg",
];

const ProjectsPage = () => {
  const [selectedImg, setSelectedImg] = useState(null);

  return (
    <section
      id="ProjectsPage"
      className="relative py-20 md:py-28 bg-white overflow-hidden"
    >
      {/* Decorative pattern */}
      <div className="absolute inset-0 bg-dot-pattern opacity-50" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[40rem] h-[40rem] bg-brand-100/40 rounded-full blur-3xl -z-0" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center max-w-3xl mx-auto mb-12"
        >
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-semibold tracking-wider uppercase bg-brand-50 text-brand-700 mb-5">
            <span className="w-1.5 h-1.5 rounded-full bg-brand-500" />
            Portfolio
          </span>
          <h2 className="font-oswald text-3xl sm:text-4xl lg:text-5xl font-semibold text-slate-900 leading-tight mb-4">
            Project{" "}
            <span className="text-gradient">Highlights</span>
          </h2>
          <p className="font-overpass text-base lg:text-lg text-slate-600 leading-relaxed">
            Dokumentasi proyek terbaik kami dalam bidang pengolahan limbah,
            lingkungan, dan teknologi air.
          </p>
        </motion.div>

        {/* Masonry Grid */}
        <div className="columns-2 md:columns-3 lg:columns-4 gap-4 lg:gap-6 space-y-4 lg:space-y-6">
          {projectImages.map((src, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: (idx % 4) * 0.1 }}
              className="break-inside-avoid group relative overflow-hidden rounded-2xl shadow-medium hover:shadow-strong transition-all cursor-pointer"
              onClick={() => setSelectedImg(src)}
            >
              <img
                src={src}
                alt={`Project ${idx + 1}`}
                className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-110"
                loading="lazy"
              />
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-slate-900/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <div className="absolute inset-0 flex flex-col justify-end p-4 lg:p-5 opacity-0 group-hover:opacity-100 transition-all duration-500 translate-y-4 group-hover:translate-y-0">
                <span className="text-white/80 text-xs font-semibold tracking-wider uppercase mb-1">
                  Project #{String(idx + 1).padStart(2, "0")}
                </span>
                <div className="flex items-center justify-between">
                  <h3 className="font-oswald text-white text-lg lg:text-xl font-semibold">
                    Defra Project
                  </h3>
                  <div className="w-9 h-9 rounded-full bg-white/20 backdrop-blur-md border border-white/30 flex items-center justify-center text-white">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      <AnimatePresence>
        {selectedImg && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[60] bg-slate-950/95 backdrop-blur-md flex items-center justify-center p-4"
            onClick={() => setSelectedImg(null)}
          >
            <button
              className="absolute top-6 right-6 w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 border border-white/20 text-white flex items-center justify-center transition-colors z-10"
              onClick={() => setSelectedImg(null)}
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <motion.img
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ duration: 0.3 }}
              src={selectedImg}
              alt="Selected project"
              className="max-w-full max-h-[90vh] object-contain rounded-2xl shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

export default ProjectsPage;
